import styled from 'styled-components';
import { Paragraph } from '../paragraph/index.js';
import { Label } from '../label/index.js';
export const CharacterCounterElement = styled(Paragraph).attrs({
    variant: 'smallCompact',
    color: 'secondary',
}) ``;
export const CharacterCounterLiveRegion = styled(Label).attrs({
    elementType: 'span',
}) ``;
//# sourceMappingURL=character-counter.styles.js.map